import { biaIpTypeOptions } from "@/common/const";
import { wiaAccessTechOptions } from "@/common/const/filter-options";
import { wiaInterfaceType } from "@/common/const/filter-options/wiaInterfaceType.options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const wiaManualFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "text",
    label: "Download Speed (in Mbps)",
    name: "downloadSpeed",
    required: true,
    patternMessage: "Value not satisfied range from 0.128 to 10,000",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    inputType: "text",
    label: "Upload Speed (in Mbps)",
    name: "uploadSpeed",
    required: true,
    patternMessage: "Value not satisfied range from 0.128 to 10,000",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    inputType: "select",
    label: "Data Limit Type",
    name: "dataLimitType",
    defaultValue: "capped",
    required: true,
    options: [
      {
        label: "Capped",
        value: "capped",
      },
      {
        label: "Unlimited",
        value: "unlimited",
      },
    ],
  },
  {
    inputType: "text",
    label: "Data Limit (in GB)*",
    name: "dataLimitGB",
    required: true,
  },
  {
    inputType: "select",
    label: "Access Technology",
    name: "AccessTechnology",
    required: true,
    defaultValue: wiaAccessTechOptions[0].value,
    options: wiaAccessTechOptions,
  },
  {
    inputType: "select",
    label: "IP",
    name: "IP",
    required: true,
    defaultValue: biaIpTypeOptions[0].value,
    options: biaIpTypeOptions,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    defaultValue: contractTermsOptions[0].value,
    options: [...contractTermsOptions],
  },
  {
    inputType: "select",
    label: "CPE",
    name: "CPE",
    required: true,
    defaultValue: "Yes",
    options: [
      { label: "Yes", value: "Yes" },
      {
        label: "No",
        value: "No",
      },
    ],
  },
  {
    inputType: "select",
    label: "Interface/Handoff Type",
    name: "interface",
    required: true,
    defaultValue: wiaInterfaceType[0].value,
    options: wiaInterfaceType,
  },
];
export default wiaManualFormStrategy;
